import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PermissionsGroup = /*#__PURE__*/function (PermissionsGroup) {
  PermissionsGroup[PermissionsGroup["PERMISSIONS_GROUP_UNKNOWN"] = 0] = "PERMISSIONS_GROUP_UNKNOWN";
  PermissionsGroup[PermissionsGroup["PERMISSIONS_GROUP_MESSENGER"] = 1] = "PERMISSIONS_GROUP_MESSENGER";
  return PermissionsGroup;
}(PermissionsGroup || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MessageAttachmentType = /*#__PURE__*/function (MessageAttachmentType) {
  MessageAttachmentType[MessageAttachmentType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  MessageAttachmentType[MessageAttachmentType["IMAGE"] = 1] = "IMAGE";
  MessageAttachmentType[MessageAttachmentType["AUDIO"] = 2] = "AUDIO";
  MessageAttachmentType[MessageAttachmentType["FILE"] = 3] = "FILE";
  return MessageAttachmentType;
}(MessageAttachmentType || {});
var TokenStatus = /*#__PURE__*/function (TokenStatus) {
  TokenStatus[TokenStatus["UNKNOWN"] = 0] = "UNKNOWN";
  TokenStatus[TokenStatus["VALID"] = 1] = "VALID";
  TokenStatus[TokenStatus["INVALID"] = 2] = "INVALID";
  TokenStatus[TokenStatus["MISSING_PERMISSIONS"] = 3] = "MISSING_PERMISSIONS";
  return TokenStatus;
}(TokenStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FacebookPage {
  static fromProto(proto) {
    let m = new FacebookPage();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.canSubscribeLeadWebhooks !== 'undefined') {
      toReturn['canSubscribeLeadWebhooks'] = this.canSubscribeLeadWebhooks;
    }
    if (typeof this.tasks !== 'undefined') {
      toReturn['tasks'] = this.tasks;
    }
    return toReturn;
  }
}
class FacebookPagingRequest {
  static fromProto(proto) {
    let m = new FacebookPagingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.before !== 'undefined') {
      toReturn['before'] = this.before;
    }
    if (typeof this.after !== 'undefined') {
      toReturn['after'] = this.after;
    }
    return toReturn;
  }
}
class FacebookPagingResponse {
  static fromProto(proto) {
    let m = new FacebookPagingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.before !== 'undefined') {
      toReturn['before'] = this.before;
    }
    if (typeof this.after !== 'undefined') {
      toReturn['after'] = this.after;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class LeadGenAdForm {
  static fromProto(proto) {
    let m = new LeadGenAdForm();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.leadgenId !== 'undefined') {
      toReturn['leadgenId'] = this.leadgenId;
    }
    if (typeof this.rawJsonPayload !== 'undefined') {
      toReturn['rawJsonPayload'] = this.rawJsonPayload;
    }
    if (typeof this.adName !== 'undefined') {
      toReturn['adName'] = this.adName;
    }
    if (typeof this.campaignName !== 'undefined') {
      toReturn['campaignName'] = this.campaignName;
    }
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FacebookForm {
  static fromProto(proto) {
    let m = new FacebookForm();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.leadgenFormId !== 'undefined') {
      toReturn['leadgenFormId'] = this.leadgenFormId;
    }
    if (typeof this.leadgenFormName !== 'undefined') {
      toReturn['leadgenFormName'] = this.leadgenFormName;
    }
    if (typeof this.isEnabledForLeads !== 'undefined') {
      toReturn['isEnabledForLeads'] = this.isEnabledForLeads;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PageData {
  static fromProto(proto) {
    let m = new PageData();
    m = Object.assign(m, proto);
    if (proto.checkins) {
      m.checkins = parseInt(proto.checkins, 10);
    }
    if (proto.talkingAboutCount) {
      m.talkingAboutCount = parseInt(proto.talkingAboutCount, 10);
    }
    if (proto.ratingCount) {
      m.ratingCount = parseInt(proto.ratingCount, 10);
    }
    if (proto.wereHereCount) {
      m.wereHereCount = parseInt(proto.wereHereCount, 10);
    }
    if (proto.picture) {
      m.picture = Picture.fromProto(proto.picture);
    }
    if (proto.fanCount) {
      m.fanCount = parseInt(proto.fanCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.about !== 'undefined') {
      toReturn['about'] = this.about;
    }
    if (typeof this.canPost !== 'undefined') {
      toReturn['canPost'] = this.canPost;
    }
    if (typeof this.checkins !== 'undefined') {
      toReturn['checkins'] = this.checkins;
    }
    if (typeof this.isPublished !== 'undefined') {
      toReturn['isPublished'] = this.isPublished;
    }
    if (typeof this.talkingAboutCount !== 'undefined') {
      toReturn['talkingAboutCount'] = this.talkingAboutCount;
    }
    if (typeof this.ratingCount !== 'undefined') {
      toReturn['ratingCount'] = this.ratingCount;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.wereHereCount !== 'undefined') {
      toReturn['wereHereCount'] = this.wereHereCount;
    }
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.picture !== 'undefined' && this.picture !== null) {
      toReturn['picture'] = 'toApiJson' in this.picture ? this.picture.toApiJson() : this.picture;
    }
    if (typeof this.fanCount !== 'undefined') {
      toReturn['fanCount'] = this.fanCount;
    }
    return toReturn;
  }
}
class Picture {
  static fromProto(proto) {
    let m = new Picture();
    m = Object.assign(m, proto);
    if (proto.height) {
      m.height = parseInt(proto.height, 10);
    }
    if (proto.width) {
      m.width = parseInt(proto.width, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.height !== 'undefined') {
      toReturn['height'] = this.height;
    }
    if (typeof this.width !== 'undefined') {
      toReturn['width'] = this.width;
    }
    if (typeof this.isSilhouette !== 'undefined') {
      toReturn['isSilhouette'] = this.isSilhouette;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetUserNameRequest {
  static fromProto(proto) {
    let m = new GetUserNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    return toReturn;
  }
}
class GetUserNameResponse {
  static fromProto(proto) {
    let m = new GetUserNameResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageIndex) {
      m.pageIndex = parseInt(proto.pageIndex, 10);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageIndex !== 'undefined') {
      toReturn['pageIndex'] = this.pageIndex;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.allRows !== 'undefined') {
      toReturn['allRows'] = this.allRows;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class VerifyTokenHasScopesForFeatureRequest {
  static fromProto(proto) {
    let m = new VerifyTokenHasScopesForFeatureRequest();
    m = Object.assign(m, proto);
    if (proto.permissionsGroup) {
      m.permissionsGroup = enumStringToValue$3(PermissionsGroup, proto.permissionsGroup);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    if (typeof this.permissionsGroup !== 'undefined') {
      toReturn['permissionsGroup'] = this.permissionsGroup;
    }
    return toReturn;
  }
}
class VerifyTokenHasScopesForFeatureResponse {
  static fromProto(proto) {
    let m = new VerifyTokenHasScopesForFeatureResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tokenValid !== 'undefined') {
      toReturn['tokenValid'] = this.tokenValid;
    }
    if (typeof this.hasAllPermissions !== 'undefined') {
      toReturn['hasAllPermissions'] = this.hasAllPermissions;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AssignFacebookPageOwnerRequest {
  static fromProto(proto) {
    let m = new AssignFacebookPageOwnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.facebookPageId !== 'undefined') {
      toReturn['facebookPageId'] = this.facebookPageId;
    }
    return toReturn;
  }
}
class SendFacebookMessageRequestAttachment {
  static fromProto(proto) {
    let m = new SendFacebookMessageRequestAttachment();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$2(MessageAttachmentType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.isReusable !== 'undefined') {
      toReturn['isReusable'] = this.isReusable;
    }
    return toReturn;
  }
}
class DisableMessengerForPageRequest {
  static fromProto(proto) {
    let m = new DisableMessengerForPageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.facebookPageId !== 'undefined') {
      toReturn['facebookPageId'] = this.facebookPageId;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    return toReturn;
  }
}
class FacebookPageMessengerStateRequest {
  static fromProto(proto) {
    let m = new FacebookPageMessengerStateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.facebookUserId !== 'undefined') {
      toReturn['facebookUserId'] = this.facebookUserId;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    return toReturn;
  }
}
class FacebookPageMessengerStateResponse {
  static fromProto(proto) {
    let m = new FacebookPageMessengerStateResponse();
    m = Object.assign(m, proto);
    if (proto.tokenValid) {
      m.tokenValid = enumStringToValue$2(TokenStatus, proto.tokenValid);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messengerEnabled !== 'undefined') {
      toReturn['messengerEnabled'] = this.messengerEnabled;
    }
    if (typeof this.tokenValid !== 'undefined') {
      toReturn['tokenValid'] = this.tokenValid;
    }
    if (typeof this.isPageOwner !== 'undefined') {
      toReturn['isPageOwner'] = this.isPageOwner;
    }
    return toReturn;
  }
}
class SendFacebookMessageRequest {
  static fromProto(proto) {
    let m = new SendFacebookMessageRequest();
    m = Object.assign(m, proto);
    if (proto.attachment) {
      m.attachment = SendFacebookMessageRequestAttachment.fromProto(proto.attachment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.facebookPageId !== 'undefined') {
      toReturn['facebookPageId'] = this.facebookPageId;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.attachment !== 'undefined' && this.attachment !== null) {
      toReturn['attachment'] = 'toApiJson' in this.attachment ? this.attachment.toApiJson() : this.attachment;
    }
    return toReturn;
  }
}
class SendFacebookMessageResponse {
  static fromProto(proto) {
    let m = new SendFacebookMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateLeadGenAdFormRequest {
  static fromProto(proto) {
    let m = new CreateLeadGenAdFormRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadgenId !== 'undefined') {
      toReturn['leadgenId'] = this.leadgenId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.rawJsonPayload !== 'undefined') {
      toReturn['rawJsonPayload'] = this.rawJsonPayload;
    }
    if (typeof this.campaignName !== 'undefined') {
      toReturn['campaignName'] = this.campaignName;
    }
    if (typeof this.adName !== 'undefined') {
      toReturn['adName'] = this.adName;
    }
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    return toReturn;
  }
}
class CreateLeadGenAdFormResponse {
  static fromProto(proto) {
    let m = new CreateLeadGenAdFormResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadId !== 'undefined') {
      toReturn['leadId'] = this.leadId;
    }
    return toReturn;
  }
}
class FetchLeadsRequest {
  static fromProto(proto) {
    let m = new FetchLeadsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadIds !== 'undefined') {
      toReturn['leadIds'] = this.leadIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    return toReturn;
  }
}
class GetFormDataRequest {
  static fromProto(proto) {
    let m = new GetFormDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    return toReturn;
  }
}
class GetFormDataResponse {
  static fromProto(proto) {
    let m = new GetFormDataResponse();
    m = Object.assign(m, proto);
    if (proto.facebookForm) {
      m.facebookForm = FacebookForm.fromProto(proto.facebookForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.facebookForm !== 'undefined' && this.facebookForm !== null) {
      toReturn['facebookForm'] = 'toApiJson' in this.facebookForm ? this.facebookForm.toApiJson() : this.facebookForm;
    }
    return toReturn;
  }
}
class GetLeadGenAdFormRequest {
  static fromProto(proto) {
    let m = new GetLeadGenAdFormRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadgenId !== 'undefined') {
      toReturn['leadgenId'] = this.leadgenId;
    }
    return toReturn;
  }
}
class GetLeadGenAdFormResponse {
  static fromProto(proto) {
    let m = new GetLeadGenAdFormResponse();
    m = Object.assign(m, proto);
    if (proto.leadgenAdform) {
      m.leadgenAdform = LeadGenAdForm.fromProto(proto.leadgenAdform);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadgenAdform !== 'undefined' && this.leadgenAdform !== null) {
      toReturn['leadgenAdform'] = 'toApiJson' in this.leadgenAdform ? this.leadgenAdform.toApiJson() : this.leadgenAdform;
    }
    return toReturn;
  }
}
class GetPagesDataRequest {
  static fromProto(proto) {
    let m = new GetPagesDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.pageIds !== 'undefined') {
      toReturn['pageIds'] = this.pageIds;
    }
    return toReturn;
  }
}
class GetPagesDataResponse {
  static fromProto(proto) {
    let m = new GetPagesDataResponse();
    m = Object.assign(m, proto);
    if (proto.pageData) {
      m.pageData = proto.pageData.map(PageData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageData !== 'undefined' && this.pageData !== null) {
      toReturn['pageData'] = 'toApiJson' in this.pageData ? this.pageData.toApiJson() : this.pageData;
    }
    return toReturn;
  }
}
class ListFormsForPageRequest {
  static fromProto(proto) {
    let m = new ListFormsForPageRequest();
    m = Object.assign(m, proto);
    if (proto.facebookPaging) {
      m.facebookPaging = FacebookPagingRequest.fromProto(proto.facebookPaging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.facebookPaging !== 'undefined' && this.facebookPaging !== null) {
      toReturn['facebookPaging'] = 'toApiJson' in this.facebookPaging ? this.facebookPaging.toApiJson() : this.facebookPaging;
    }
    return toReturn;
  }
}
class ListFormsForPageResponse {
  static fromProto(proto) {
    let m = new ListFormsForPageResponse();
    m = Object.assign(m, proto);
    if (proto.facebookForms) {
      m.facebookForms = proto.facebookForms.map(FacebookForm.fromProto);
    }
    if (proto.facebookPaging) {
      m.facebookPaging = FacebookPagingResponse.fromProto(proto.facebookPaging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.facebookForms !== 'undefined' && this.facebookForms !== null) {
      toReturn['facebookForms'] = 'toApiJson' in this.facebookForms ? this.facebookForms.toApiJson() : this.facebookForms;
    }
    if (typeof this.facebookPaging !== 'undefined' && this.facebookPaging !== null) {
      toReturn['facebookPaging'] = 'toApiJson' in this.facebookPaging ? this.facebookPaging.toApiJson() : this.facebookPaging;
    }
    return toReturn;
  }
}
class ListLeadGenAdFormsByPartnerIDRequest {
  static fromProto(proto) {
    let m = new ListLeadGenAdFormsByPartnerIDRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    return toReturn;
  }
}
class ListLeadGenAdFormsByPartnerIDResponse {
  static fromProto(proto) {
    let m = new ListLeadGenAdFormsByPartnerIDResponse();
    m = Object.assign(m, proto);
    if (proto.leadgenAdforms) {
      m.leadgenAdforms = proto.leadgenAdforms.map(LeadGenAdForm.fromProto);
    }
    if (proto.paging) {
      m.paging = PagedResponseMetadata.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadgenAdforms !== 'undefined' && this.leadgenAdforms !== null) {
      toReturn['leadgenAdforms'] = 'toApiJson' in this.leadgenAdforms ? this.leadgenAdforms.toApiJson() : this.leadgenAdforms;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    return toReturn;
  }
}
class ListPagesForPartnerRequest {
  static fromProto(proto) {
    let m = new ListPagesForPartnerRequest();
    m = Object.assign(m, proto);
    if (proto.facebookPaging) {
      m.facebookPaging = FacebookPagingRequest.fromProto(proto.facebookPaging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.facebookPaging !== 'undefined' && this.facebookPaging !== null) {
      toReturn['facebookPaging'] = 'toApiJson' in this.facebookPaging ? this.facebookPaging.toApiJson() : this.facebookPaging;
    }
    return toReturn;
  }
}
class ListPagesForPartnerResponse {
  static fromProto(proto) {
    let m = new ListPagesForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.facebookPage) {
      m.facebookPage = proto.facebookPage.map(FacebookPage.fromProto);
    }
    if (proto.facebookPaging) {
      m.facebookPaging = FacebookPagingResponse.fromProto(proto.facebookPaging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.facebookPage !== 'undefined' && this.facebookPage !== null) {
      toReturn['facebookPage'] = 'toApiJson' in this.facebookPage ? this.facebookPage.toApiJson() : this.facebookPage;
    }
    if (typeof this.facebookPaging !== 'undefined' && this.facebookPaging !== null) {
      toReturn['facebookPaging'] = 'toApiJson' in this.facebookPaging ? this.facebookPaging.toApiJson() : this.facebookPaging;
    }
    return toReturn;
  }
}
class PartnerLeadAdsTokenStatusRequest {
  static fromProto(proto) {
    let m = new PartnerLeadAdsTokenStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class PartnerLeadAdsTokenStatusResponse {
  static fromProto(proto) {
    let m = new PartnerLeadAdsTokenStatusResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exists !== 'undefined') {
      toReturn['exists'] = this.exists;
    }
    if (typeof this.valid !== 'undefined') {
      toReturn['valid'] = this.valid;
    }
    return toReturn;
  }
}
class RegisterSessionToConnectLeadAdsForPartnerRequest {
  static fromProto(proto) {
    let m = new RegisterSessionToConnectLeadAdsForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class RegisterSessionToConnectLeadAdsForPartnerResponse {
  static fromProto(proto) {
    let m = new RegisterSessionToConnectLeadAdsForPartnerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sessionId !== 'undefined') {
      toReturn['sessionId'] = this.sessionId;
    }
    return toReturn;
  }
}
class SubscribePageToAppRequest {
  static fromProto(proto) {
    let m = new SubscribePageToAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    return toReturn;
  }
}
class UnsubscribePageFromAppRequest {
  static fromProto(proto) {
    let m = new UnsubscribePageFromAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    return toReturn;
  }
}
class VerifyLeadGenTokensRequest {
  static fromProto(proto) {
    let m = new VerifyLeadGenTokensRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    return toReturn;
  }
}
class VerifyLeadGenTokensResponse {
  static fromProto(proto) {
    let m = new VerifyLeadGenTokensResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exists !== 'undefined') {
      toReturn['exists'] = this.exists;
    }
    if (typeof this.valid !== 'undefined') {
      toReturn['valid'] = this.valid;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'facebook-api.vendasta-local.com',
  'test': '',
  'demo': 'facebook-api-demo.apigateway.co',
  'prod': 'facebook-api-prod.apigateway.co',
  'production': 'facebook-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let FacebookApiService = /*#__PURE__*/(() => {
  class FacebookApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    registerSessionToConnectLeadAdsForPartner(r) {
      const request = r.toApiJson ? r : new RegisterSessionToConnectLeadAdsForPartnerRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/RegisterSessionToConnectLeadAdsForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => RegisterSessionToConnectLeadAdsForPartnerResponse.fromProto(resp)));
    }
    partnerLeadAdsTokenStatus(r) {
      const request = r.toApiJson ? r : new PartnerLeadAdsTokenStatusRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/PartnerLeadAdsTokenStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => PartnerLeadAdsTokenStatusResponse.fromProto(resp)));
    }
    subscribePageToApp(r) {
      const request = r.toApiJson ? r : new SubscribePageToAppRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/SubscribePageToApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unsubscribePageFromApp(r) {
      const request = r.toApiJson ? r : new UnsubscribePageFromAppRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/UnsubscribePageFromApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    verifyLeadGenTokens(r) {
      const request = r.toApiJson ? r : new VerifyLeadGenTokensRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/VerifyLeadGenTokens", request.toApiJson(), this.apiOptions()).pipe(map(resp => VerifyLeadGenTokensResponse.fromProto(resp)));
    }
    listPagesForPartner(r) {
      const request = r.toApiJson ? r : new ListPagesForPartnerRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/ListPagesForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPagesForPartnerResponse.fromProto(resp)));
    }
    listFormsForPage(r) {
      const request = r.toApiJson ? r : new ListFormsForPageRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/ListFormsForPage", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFormsForPageResponse.fromProto(resp)));
    }
    getFormData(r) {
      const request = r.toApiJson ? r : new GetFormDataRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/GetFormData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFormDataResponse.fromProto(resp)));
    }
    getPagesData(r) {
      const request = r.toApiJson ? r : new GetPagesDataRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/GetPagesData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPagesDataResponse.fromProto(resp)));
    }
    listLeadGenAdFormsByPartnerId(r) {
      const request = r.toApiJson ? r : new ListLeadGenAdFormsByPartnerIDRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/ListLeadGenAdFormsByPartnerID", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLeadGenAdFormsByPartnerIDResponse.fromProto(resp)));
    }
    getLeadGenAdForm(r) {
      const request = r.toApiJson ? r : new GetLeadGenAdFormRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/GetLeadGenAdForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLeadGenAdFormResponse.fromProto(resp)));
    }
    createLeadGenAdForm(r) {
      const request = r.toApiJson ? r : new CreateLeadGenAdFormRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/CreateLeadGenAdForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateLeadGenAdFormResponse.fromProto(resp)));
    }
    fetchLeads(r) {
      const request = r.toApiJson ? r : new FetchLeadsRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/FetchLeads", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    verifyTokenHasScopesForFeature(r) {
      const request = r.toApiJson ? r : new VerifyTokenHasScopesForFeatureRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/VerifyTokenHasScopesForFeature", request.toApiJson(), this.apiOptions()).pipe(map(resp => VerifyTokenHasScopesForFeatureResponse.fromProto(resp)));
    }
    getUserName(r) {
      const request = r.toApiJson ? r : new GetUserNameRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/GetUserName", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUserNameResponse.fromProto(resp)));
    }
    assignFacebookPageOwner(r) {
      const request = r.toApiJson ? r : new AssignFacebookPageOwnerRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/AssignFacebookPageOwner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendFacebookMessage(r) {
      const request = r.toApiJson ? r : new SendFacebookMessageRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/SendFacebookMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendFacebookMessageResponse.fromProto(resp)));
    }
    facebookPageMessengerState(r) {
      const request = r.toApiJson ? r : new FacebookPageMessengerStateRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/FacebookPageMessengerState", request.toApiJson(), this.apiOptions()).pipe(map(resp => FacebookPageMessengerStateResponse.fromProto(resp)));
    }
    disableMessengerForPage(r) {
      const request = r.toApiJson ? r : new DisableMessengerForPageRequest(r);
      return this.http.post(this._host + "/facebook.v1.Facebook/DisableMessengerForPage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  FacebookApiService.ɵfac = function FacebookApiService_Factory(t) {
    return new (t || FacebookApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FacebookApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FacebookApiService,
    factory: FacebookApiService.ɵfac,
    providedIn: 'root'
  });
  return FacebookApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { FacebookApiService, TokenStatus };
